import { Icon, IconButton, Tooltip } from "@mui/material";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { MDTypography } from "../../../Component/Common/Components/MDTypography";
import { PublicEventSectionItem } from "../../../Component/Model/Dto/Academy";
import { LongTableDateHelper, TableTimeHelper } from "../../../Component/Model/helpers";
import { TableColumn } from "../../../Component/Model/Table/Table";

interface PublicEventsSectionRow {
    id: number;
    date: string | undefined;
    time: string;
    url: string;
}

interface PublicEventsSectionTable {
    columns: Array<TableColumn>;
    rows: Array<PublicEventsSectionRow>;
}

const getActionButton = (url: string) =>{
    return(
        <IconButton onClick={() => window.open(url)} >
        <Tooltip title={"Book Now"}>
            <MDTypography variant="caption" color="primary" lineHeight={1} sx={{ cursor: "pointer", mx: 0 }}>
            <Icon color="inherit" fontSize="small">launch</Icon>
            </MDTypography>
        </Tooltip>
        </IconButton>
    )
}

export function  PublicEventSectionTableMapper(dataObject: PublicEventSectionItem.DtoIn[]): PublicEventsSectionTable | undefined {
    const columns = [
        { Header: 'Date', accessor: 'date', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Time', accessor: 'time', Cell: ({ value }: any) => <DefaultCell value={value}/>, disableSortBy: true },
        { Header: 'Topic', accessor: 'topic', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} maxWidth={"450px"}/>, disableSortBy: true },
        { Header: 'Actions', accessor: 'url', Cell: ({ value }: any) => getActionButton(value), disableSortBy: true },
    ];

    if (dataObject !== undefined && dataObject.length > 0) {
        const rows = dataObject.map((item:PublicEventSectionItem.DtoIn) => ({
            id: item.id,
            date: LongTableDateHelper(item.fromDateTime) !== undefined ? LongTableDateHelper(item.fromDateTime) : "Undefined",
            time: TableTimeHelper(item.fromDateTime) + " - " + TableTimeHelper(item.toDateTime),
            topic: item.description,
            url: item.url
        }));

        return { columns: columns, rows: rows };
        
    } else {
        return { columns: columns, rows: [] };
    }
}